module.exports = "/_next/static/images/squarespace-logo-08011383d235eb67ee7745f2144ceb20.png";